import React from 'react';
import {
    Text,
} from '@zillow/constellation';

const achTextRecurring = ` I authorize Zillow Group, Inc. (“Zillow”),
 to initiate withdrawals from my bank account on record, for 
 the amounts due to Zillow. The bank I have listed is authorized to
 charge to my checking or savings account the withdrawals initiated 
 by Zillow. I acknowledge Zillow may discontinue automated payment
 withdrawals at any time if withdrawal attempts are unsuccessful.
 Any open balances will be applied against this payment method. 
 This authorization will remain in full force and in effect until 
 I disable Auto Pay in the online billing portal. To opt out of Auto Pay, 
 please navigate to the Settings subtab and uncheck Auto Pay for your ACH payment and Save.`;

const achTextOneTime = ` I authorize Zillow Group, Inc. (“Zillow”), 
    to initiate a single ACH/electronic debit for the amounts due to 
    Zillow from my bank account on record. The bank I have listed is 
    authorized to charge to my checking or savings account the withdrawals 
    initiated by Zillow. This authorization is irrevocable once selected and processed. 
    For regularly scheduled payments, to ensure this payment method does not recur, 
    switch Auto Pay to Off and Save. For customers making a prepayment on their account,
     no further changes are required. `;

const TermsAndConditionsWidget = ({
    accountPaymentMethods,
    selectedCreditCardId,
    isSinglePayment,
}) => {
    const selectedPaymentMethod = accountPaymentMethods
        .find(method => method.paymentMethodId === selectedCreditCardId);
    if (selectedPaymentMethod && selectedPaymentMethod.paymentType === 'ACH') {
        // TODO: waiting on finalized ach text from leagal, this is filler
        return (
            <div>
                <Text fontType="bodySmall" as="p">
                    By clicking
                    {' '}
                    <Text fontType="bodySmall" as="b">“Yes, I accept the Terms & Conditions”</Text>
                    {' '}
                    below,
                    {isSinglePayment ? achTextOneTime : achTextRecurring}
                </Text>
            </div>
        );
    }
    return (
        <div id="TermsAndConditionsWidget">
            <Text fontType="bodySmall" as="p">
                By clicking
                {' '}
                <Text fontType="bodySmall" as="b">“Yes, I accept the Terms & Conditions”</Text>
                {' '}
                below, you agree to enabling auto pay, which will automatically deduct from your selected payment
                method on the 15th of each month.
                You will be sent a summary of your account to be charged to your email address on record
                by the 14th of each month. To cancel auto pay or to change your payment method,
                visit the Payments Settings Page. Any changes for the current month must be made by the 14th
                to avoid auto pay on the 15th.
            </Text>
        </div>
    );
};

export default TermsAndConditionsWidget;
